import React from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  Divider,
  Chip,
  Button,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useLeadForm } from "../FloatingIcon/useLeadForm";

const SmartSummary = () => {
  const { state } = useLocation();

  const {
    type,
    capacity,
    area,
    unit,
    structure,
    structureHeight,
    billAmount,
    savings,
    panel,
    inverter,
    battery,
    wiring,
  } = state || {};

  const isOffGrid = type === "offGrid";

  const estimatedCost = capacity * 65000;
  const roiYears =
    Math.round((estimatedCost / (savings?.monthly || 1)) * 10) / 10;
  const lifetimeSavings = (savings?.monthly || 0) * 12 * 25;

  const { showLeadForm } = useLeadForm();
  const handleShareClick = (state, type) => {
    showLeadForm(state, type, (formData, originalState, shareType) => {
      console.log("Form Submitted:", formData);
      console.log("Came from:", shareType);
      console.log("Attached Data:", originalState);

      // handle WhatsApp or Email logic here
    });
  };

  return (
    <Box px={2} maxWidth="1000px" mx="auto">
      <Typography variant="h4" fontWeight={600} textAlign="center" gutterBottom>
        🧠 Smart Summary
        <Chip
          label={isOffGrid ? "Off-Grid System" : "On-Grid System"}
          color={isOffGrid ? "secondary" : "primary"}
          size="small"
          sx={{ ml: 2 }}
        />
      </Typography>

      <div style={{ display: "flex", gap: "1.5rem", alignItems: "stretch" }}>
        <div style={{ flex: 1 }}>
          <Paper
            elevation={2}
            sx={{ height: "100%", p: 3, borderRadius: 4, bgcolor: "#fcfcfc" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                  }}
                >
                  <Typography variant="h6" gutterBottom>
                    📊 System Snapshot
                  </Typography>
                  <Divider sx={{ mb: 2 }} />

                  <Grid container spacing={2}>
                    {[
                      {
                        label: "System Type",
                        value: isOffGrid ? "Off-Grid" : "On-Grid",
                      },
                      { label: "Capacity", value: `${capacity} kW` },
                      { label: "Rooftop Area", value: `${area} ${unit}` },
                      { label: "Structure Height", value: structureHeight },
                      { label: "Current Bill", value: `₹${billAmount}` },
                      {
                        label: "Estimated Monthly Savings",
                        value: `₹${savings?.monthly?.toLocaleString()}`,
                      },
                    ].map((item, i) => (
                      <Grid item xs={6} key={i}>
                        <Typography variant="body2" color="text.secondary">
                          {item.label}
                        </Typography>
                        <Typography fontWeight={600}>{item.value}</Typography>
                      </Grid>
                    ))}
                  </Grid>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                  }}
                >
                  {/* Benifit Brought to Ecosytem through Solar & raw calculation of feature through data */}
                  <Box
                    sx={{
                      mt: 3,
                      p: 2.5,
                      borderRadius: 3,
                      bgcolor: "#f0fff4",
                      borderLeft: "5px solid #4caf50",
                    }}
                  >
                    <Typography variant="h6" gutterBottom>
                      🌿 Environmental Impact
                    </Typography>
                    <Divider sx={{ mb: 2 }} />

                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "1.5rem",
                        justifyContent: "space-between",
                      }}
                    >
                      {[
                        {
                          label: "CO₂ Saved / Year",
                          value: `${(capacity * 1200).toLocaleString()} kg`,
                        },
                        {
                          label: "Equivalent Trees Planted",
                          value: `${Math.round(
                            (capacity * 1200) / 21.77
                          ).toLocaleString()} trees`,
                        },
                        {
                          label: "Car Kilometers Offset",
                          value: `${Math.round(
                            (capacity * 1200) / 0.21
                          ).toLocaleString()} km`,
                        },
                        {
                          label: "Coal Burned Avoided",
                          value: `${Math.round(
                            (capacity * 1200) / 2.2
                          ).toLocaleString()} kg`,
                        },
                      ].map((item, i) => (
                        <div
                          key={i}
                          style={{
                            flex: "0 1 calc(50% - 1rem)",
                            display: "flex",
                            flexDirection: "column",
                            gap: "0.25rem",
                          }}
                        >
                          <Typography variant="body2" color="text.secondary">
                            {item.label}
                          </Typography>
                          <Typography fontWeight={600}>{item.value}</Typography>
                        </div>
                      ))}
                    </div>
                  </Box>
                </div>
              </div>
              <div className="">
                <Box
                  textAlign="center"
                  mt={4}
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  gap={2}
                >
                  <Typography variant="subtitle1" fontWeight={500}>
                    Share Personalised Pamplet Instantly
                  </Typography>

                  <Grid
                    container
                    spacing={2}
                    justifyContent="center"
                    maxWidth="400px"
                  >
                    <Grid item xs={6}>
                      <Button
                        variant="outlined"
                        fullWidth
                        color="success"
                        onClick={() => handleShareClick(state, "Whatsapp")}
                      >
                        📤 WhatsApp
                      </Button>
                    </Grid>

                    <Grid item xs={6}>
                      <Button
                        variant="outlined"
                        fullWidth
                        color="primary"
                        onClick={() => handleShareClick(state, "Email")}
                      >
                        📧 Email
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </div>
            </div>
          </Paper>
        </div>

        <div style={{ flex: 1 }}>
          <Paper
            elevation={2}
            sx={{ mb: 3, p: 3, borderRadius: 4, bgcolor: "#f9f9fb" }}
          >
            <Typography variant="h6" gutterBottom>
              🧹 Selected Kit
            </Typography>
            <Divider sx={{ mb: 2 }} />

            {[
              { label: "Solar Panel", value: panel },
              { label: "Inverter", value: inverter },
              { label: "Battery", value: battery || "Not Included" },
              { label: "Wiring", value: wiring },
              { label: "Structure", value: structure },
            ].map((item, i) => (
              <Typography key={i} sx={{ mb: 1 }}>
                • <strong>{item.label}:</strong> {item.value}
              </Typography>
            ))}
          </Paper>

          <Paper
            elevation={2}
            sx={{ p: 3, borderRadius: 4, bgcolor: "#fff9f0" }}
          >
            <Typography variant="h6" gutterBottom>
              💰 Proposal Preview
            </Typography>
            <Divider sx={{ mb: 2 }} />

            {[
              {
                label: "Estimated Cost",
                value: `₹${estimatedCost.toLocaleString()}`,
              },
              {
                label: "ROI Period",
                value: `${roiYears} Years`,
              },
              {
                label: "Lifetime Savings (25 yrs)",
                value: `₹${lifetimeSavings.toLocaleString()}`,
              },
            ].map((item, i) => (
              <Typography key={i} sx={{ mb: 1.5 }}>
                • <strong>{item.label}:</strong> {item.value}
              </Typography>
            ))}
          </Paper>
        </div>
      </div>
    </Box>
  );
};

export default SmartSummary;
